// AppLayout.jsx
import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from './Sidebar';
import Menubar from './Menubar';
import Dashboard from './Dashboard';
import Students from '../Students';
import Notifications from '../Notifications';
import Events from '../Events';
import Assignments from '../Assignments';
import Attendance from '../Attendance';
import FeeStatement from '../FeeStatement';
import FeeStatementFilter from '../FeeStatementFilter';
import ReportForm from '../ReportForm';
import ReportFormFilter from '../ReportFormFilter';
import './AppLayout.css';

const AppLayout = () => {
   const [isSidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 992);

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  return (
    <div className={`sidebar-container ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}>
      
      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} />

      {/* Sidebar Toggle Button */}
      <button
        className={`sidebar-toggle-btn d-lg-none ${isSidebarOpen ? "open" : ""}`}
        onClick={toggleSidebar}
      >
        <i className="fas fa-bars"></i>
      </button>

      {/* Main Area (Menubar + Content) */}
      <div className="main-area">
        {/* Menubar */}
        <Menubar toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />

        {/* Content */}
        <div className="content-container">
          <Routes>
            <Route path="" element={<Dashboard />} />
            <Route path="students" element={<Students />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="events" element={<Events />} />
            <Route path="fee_statement_filter" element={<FeeStatementFilter />} />
            <Route path="fee_statement/:company_id/:parent_no/:sibling/:date_filter" element={<FeeStatement />} />
            <Route path="report_form_filter" element={<ReportFormFilter />} />
            <Route path="report_form/:company_id/:sibling/:batch_id" element={<ReportForm />} />
            <Route path="assignments" element={<Assignments />} />
            <Route path="attendance" element={<Attendance />} />

          </Routes>
        </div>
      </div>
    </div>
  );

};

export default AppLayout;
